<template>
  <router-view v-slot="{ Component }">
    <keep-alive include="localList">
      <component class="view" :is="Component" />
    </keep-alive>
  </router-view>
</template>

<style lang="less">
*,
*::after,
*::before {
  box-sizing: border-box;
}
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
span,
body,
html {
  margin: 0;
}
</style>
